import React from 'react'
import classnames from 'classnames'
import { Icon, Number } from 'components'
import indianize from 'utils/indianize'

export default class Allocation extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.maxAllocation !== nextProps.maxAllocation) {
      this.props.handleUpdate(
        Math.min(this.props.allocation, nextProps.maxAllocation)
      )
    }
  }

  render() {
    const {
      active,
      icon,
      title,
      monthly,
      allocation,
      maxAllocation,
      handleUpdate,
      investStartAge,
    } = this.props
    const classNames = classnames('allocation', {
      active: active,
    })
    return (
      <div className={classNames}>
        <h5>{title}</h5>
        <Icon name={icon} />
        <Number
          minimal
          currency
          value={Math.min(allocation, maxAllocation)}
          min={0}
          max={maxAllocation}
          handleUpdate={handleUpdate}
        />
        <span>
          {indianize(monthly)} <span>({investStartAge})</span>
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Allocation.js